import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import * as XLSX from 'xlsx'
import { Booking } from '@/types'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export const generateBookingsPDF = (bookings: Booking[], period: string, orgName: string) => {
    const doc = new jsPDF()

    // Header
    doc.setFontSize(18)
    doc.text(`Relatório de Reservas - ${orgName}`, 14, 20)

    doc.setFontSize(10)
    doc.setTextColor(100)
    doc.text(`Período: ${period}`, 14, 28)
    doc.text(`Gerado em: ${format(new Date(), 'dd/MM/yyyy HH:mm', { locale: ptBR })}`, 14, 33)

    // Table Data
    const tableData = bookings.map(b => [
        format(b.createdAt.toDate(), 'dd/MM/yyyy HH:mm'),
        (b as any).spaceName || 'N/A',
        (b as any).userName || 'N/A',
        b.status,
        `R$ ${b.totalPrice?.toFixed(2) || '0.00'}`
    ])

    // Table
    autoTable(doc, {
        head: [['Data', 'Espaço', 'Usuário', 'Status', 'Valor']],
        body: tableData,
        startY: 40,
        styles: { fontSize: 8 },
        headStyles: { fillColor: [0, 28, 40] } // Primary color
    })

    // Footer summary
    const totalRevenue = bookings.reduce((sum, b) => sum + (b.totalPrice || 0), 0)
    const finalY = (doc as any).lastAutoTable.finalY + 10

    doc.setFontSize(12)
    doc.setTextColor(0)
    doc.text(`Total de Registros: ${bookings.length}`, 14, finalY)
    doc.text(`Receita Total: R$ ${totalRevenue.toFixed(2)}`, 14, finalY + 7)

    doc.save(`relatorio_reservas_${format(new Date(), 'yyyy-MM-dd')}.pdf`)
}

export const generateBookingsExcel = (bookings: Booking[], period: string) => {
    const data = bookings.map(b => ({
        ID: b.id,
        Data_Criacao: format(b.createdAt.toDate(), 'dd/MM/yyyy HH:mm'),
        Espaco: (b as any).spaceName || 'N/A',
        Usuario: (b as any).userName || 'N/A',
        Status: b.status,
        Valor: b.totalPrice || 0,
        Inicio_Reserva: b.start ? format(b.start.toDate(), 'dd/MM/yyyy HH:mm') : '-',
        Fim_Reserva: b.end ? format(b.end.toDate(), 'dd/MM/yyyy HH:mm') : '-'
    }))

    const worksheet = XLSX.utils.json_to_sheet(data)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reservas")

    XLSX.writeFile(workbook, `relatorio_reservas_${period}_${format(new Date(), 'yyyy-MM-dd')}.xlsx`)
}

export const generateOccupancyPDF = (chartData: any[], period: string, orgName: string) => {
    const doc = new jsPDF()

    // Header
    doc.setFontSize(18)
    doc.text(`Relatório de Ocupação - ${orgName}`, 14, 20)

    doc.setFontSize(10)
    doc.setTextColor(100)
    doc.text(`Período: ${period}`, 14, 28)
    doc.text(`Gerado em: ${format(new Date(), 'dd/MM/yyyy HH:mm', { locale: ptBR })}`, 14, 33)

    // Table Data
    const tableData = chartData.map(d => [
        d.name,
        d.reservas.toString(),
        `R$ ${d.receita.toFixed(2)}`
    ])

    // Table
    autoTable(doc, {
        head: [['Espaço', 'Total de Reservas', 'Receita Gerada']],
        body: tableData,
        startY: 40,
        styles: { fontSize: 10 },
        headStyles: { fillColor: [0, 28, 40] }, // Primary color
        columnStyles: {
            0: { fontStyle: 'bold' },
            2: { halign: 'right' }
        }
    })

    // Footer summary
    const totalReservas = chartData.reduce((sum, d) => sum + d.reservas, 0)
    const totalReceita = chartData.reduce((sum, d) => sum + d.receita, 0)
    const finalY = (doc as any).lastAutoTable.finalY + 10

    doc.setFontSize(12)
    doc.setTextColor(0)
    doc.text(`Total Geral de Reservas: ${totalReservas}`, 14, finalY)
    doc.text(`Receita Total do Período: R$ ${totalReceita.toFixed(2)}`, 14, finalY + 7)

    doc.save(`relatorio_ocupacao_${format(new Date(), 'yyyy-MM-dd')}.pdf`)
}
